import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable } from "rxjs/Observable";
import {environment} from "../../environments/environment";


import {Quote, Job} from '../models/interfaces'


@Injectable({
  providedIn: 'root'
})
export class QuoteService {

constructor(private http: HttpClient ) { }

    public addTasktoJob(jobId: number, task : any) {
        return this.http.post(environment.APIENDPOINT + "/jobs/"+jobId+"/tasks", task,
            {
                headers: this.setHeaders(),
                responseType: 'json'
            }
        );
    }

    public setJobAsCompleted(jobId: number, status : any) {
        return this.http.post(environment.APIENDPOINT + "/jobs/"+jobId+"/status", status,
            {
                headers: this.setHeaders(),
                responseType: 'json'
            }
        );
    }

    public addEiteQuote( quote  : Quote) {
        return this.http.post(environment.APIENDPOINT + "/quotes", quote,
            {
                headers: this.setHeaders(),
                responseType: 'json'
            }
        );
    }


    public searchQuotes(searchString: string, page: number){
//'/quotes/search?searchString='
        if(searchString != null &&  searchString.trim() != ""){
            return this.http.get<Quote[]>(environment.APIENDPOINT + '/quotes?searchTerm='+searchString+'&page='+page+'&size=10', {
                headers: this.setHeaders(),
                responseType: 'json'
              });
        }
        else{
            return this.http.get<Quote[]>(environment.APIENDPOINT + '/quotes/list?page='+page+'&size=10', {
                headers: this.setHeaders(),
                responseType: 'json'
              });
        }
    }

  


    public searchJobsForQuote(searchString: string, page: number, startDate?: string, endDate?: string){
        let dateParams = '';
        if (startDate) {
          dateParams += '&startDate=' + encodeURIComponent(startDate);
        }
        if (endDate) {
          dateParams += '&endDate=' + encodeURIComponent(endDate);
        }

        if(searchString != null &&  searchString.trim() != ""){
            return this.http.get<Quote[]>(environment.APIENDPOINT + '/jobs/search?jobType=2&searchTerm='+encodeURIComponent(searchString)+'&page='+page+'&size=5' + dateParams, {
                headers: this.setHeaders(),
                responseType: 'json'
              });
        }
        else{
            return this.http.get<Quote[]>(environment.APIENDPOINT + '/jobs/search?jobType=2&searchTerm=&page='+page+'&size=10' + dateParams, {
                headers: this.setHeaders(),
                responseType: 'json'
              });
        }
    }
    
    public searchJobsForQuoteOLD(searchString: string, page: number){

        if(searchString != null &&  searchString.trim() != ""){
            return this.http.get<Quote[]>(environment.APIENDPOINT + '/jobs?searchTerm='+searchString+'&page='+page+'&size=5', {
                headers: this.setHeaders(),
                responseType: 'json'
              });
        }
        else{
            return this.http.get<Quote[]>(environment.APIENDPOINT + '/jobs/list?page='+page+'&size=10', {
                headers: this.setHeaders(),
                responseType: 'json'
              });
        }
    }


    public getQuoteJob(jobID : number) : Observable<Job> {
        return this.http.get<Job>(environment.APIENDPOINT + '/jobs/'+jobID, {
            headers: this.setHeaders(),
            responseType: 'json'
          });
   
}

    public getQuote(quoteID: number){

            return this.http.get<Quote>(environment.APIENDPOINT + '/quotes/'+quoteID, {
                headers: this.setHeaders(),
                responseType: 'json'
              });
       
    }




    public sendQuoteToCustomer(QuoteId: number) {
        return this.http.post(environment.APIENDPOINT + "/quotes/"+QuoteId+"/send",null,
            {
                headers: this.setHeaders(),
                responseType: 'json'
            }
        );
    }

    //quotes/noAuth/{code}/approve

    public approveQuote(code: string , tenant : string) {
        return this.http.post(environment.APIENDPOINT + "/quotes/noAuth/"+code+"/approve",null,
            {
                headers: this.setTenantHeader(tenant),
                responseType: 'json'
            }
        );
    }

    public rejectQuote(code: string, tenant : string) {
        return this.http.post(environment.APIENDPOINT + "/quotes/noAuth/"+code+"/reject",null,
            {
                headers: this.setTenantHeader(tenant),
                responseType: 'json'
            }
        );
    }


    public getQuoteByCode(code: string, tenant : string){

        return this.http.get<Quote>(environment.APIENDPOINT + '/quotes/noAuth/'+code, {
            headers: this.setTenantHeader(tenant),
            responseType: 'json'
          });
   
}

private setTenantHeader(tenant : string) {
    let authHeader = new HttpHeaders({'X-Tenant' : tenant });
    return authHeader;
  }


  private setHeaders() {
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let userTenant = localStorage.getItem('userTenant');
    let authHeader = new HttpHeaders({'Authorization': 'Bearer ' + currentUser.token , 'X-Tenant' : userTenant });
    return authHeader;
  }



}


